import { IAPIAction } from "us.collection/interfaces";
import { ClosureCodes } from "us.collection.admin/constants/Actions";
import { IClosureCodesActions } from "us.collection.admin/interfaces";

export const closureCodes: Readonly<IAPIAction & IClosureCodesActions> = {
  closureCode: {
    get: (data) => ({
      type: ClosureCodes.GET_CLOSURE_CODES,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ClosureCodes.GET_CLOSURE_CODES_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ClosureCodes.GET_CLOSURE_CODES_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },

  newClosureCode: {
    save: (data) => ({
      type: ClosureCodes.ADD_CLOSURE_CODES,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    update: (data) => ({
      type: ClosureCodes.UPDATE_CLOSURE_CODES,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ClosureCodes.ADD_CLOSURE_CODES_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ClosureCodes.ADD_CLOSURE_CODES_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
    openDrawer: (data) => ({
      type: ClosureCodes.OPEN_CLOSURE_CODE_DRAWER,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
  },

  closureCodeHistory: {
    get: (data) => ({
      type: ClosureCodes.GET_CLOSURE_CODE_HISTORY,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ClosureCodes.GET_CLOSURE_CODE_HISTORY_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ClosureCodes.GET_CLOSURE_CODE_HISTORY_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },

  closureCodeDeletion: {
    delete: (data) => ({
      type: ClosureCodes.DELETE_CLOSURE_CODE,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: ClosureCodes.DELETE_CLOSURE_CODE_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: ClosureCodes.DELETE_CLOSURE_CODE_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },
};
